import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRoutes from 'routes.js';
import './index.css';
import 'services/axios.Config'
import { DeviceProvider } from 'components/DeviceContext.js';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <DeviceProvider>
				<ThemeProvider theme={theme}>
            <AppRoutes />
						</ThemeProvider>
        </DeviceProvider>
    </React.StrictMode>
);


